import { render } from "./ArticleSnb.vue?vue&type=template&id=f6945e64"
import script from "./ArticleSnb.vue?vue&type=script&lang=js"
export * from "./ArticleSnb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__